import { Loader } from "components/Common/Loader";
import Render from "components/Common/Render";
import React from "react";

interface IButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "primary" | "secondary";
  disabled?: boolean;
  customClass?: string;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  loading?: boolean;
}
const Button: React.FC<IButtonProps> = ({
  label,
  onClick,
  disabled,
  type = "button",
  variant = "primary",
  loading = false,
  customClass,
  rightIcon,
  leftIcon,
}) => {
  const primaryButtonStyle = "text-white bg-trueBlue";
  const secondaryButtonStyle = "text-primary bg-white border border-primary";
  const disbaledStyle = "opacity-50 cursor-not-allowed";

  const buttonClass =
    variant === "primary" ? primaryButtonStyle : secondaryButtonStyle;

  return (
    <button
      type={type}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      className={`${buttonClass} font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2 w-full ${customClass} ${
        disabled ? disbaledStyle : ""
      }`}
    >
      <div className="flex flex-row gap-2 justify-center ">
        <div>
          <Render when={!!rightIcon}>{rightIcon}</Render>
        </div>
        {loading ? <Loader size={4} color="transparent" /> : label}
        <div>
          <Render when={!!leftIcon}>{leftIcon}</Render>
        </div>
      </div>
    </button>
  );
};

export default Button;
